import { Box } from "@mui/joy";
import CommonModal from "../../common/CommonModal";
import Pagination from "../../common/Pagination";
import CustomerExcursionsTab from "./CustomerExcursionsTab";
import { useCustomerExcursions } from "./useCustomerExcursions";

type Props = {
  open: boolean;
  onClose: () => void;
  customerId: number;
  customerName?: string;
};

export default function CustomerExcursionsModal({
  open,
  onClose,
  customerId,
  customerName,
}: Props) {
  const exc = useCustomerExcursions(open ? customerId : undefined);

  return (
    <CommonModal
      open={open}
      onClose={onClose}
      title={customerName ? `Sorties – ${customerName}` : "Sorties"}
      size="xl"
      fitContentHeight
    >
      <CustomerExcursionsTab
        excursions={exc.excursions}
        loading={exc.loading}
        totalItems={exc.totalItems}
      />
      {exc.totalPages > 0 && (
        <Box sx={{ flexShrink: 0 }}>
          <Pagination
            currentPage={exc.currentPage}
            totalPages={exc.totalPages}
            totalItems={exc.totalItems}
            itemsPerPage={exc.itemsPerPage}
            onPageChange={exc.handlePageChange}
            onItemsPerPageChange={exc.handleItemsPerPageChange}
            loading={exc.loading}
          />
        </Box>
      )}
    </CommonModal>
  );
}
